'use client';

import { useRouter } from 'next/navigation';

import { AppRoutes } from '@/constants';
import { useAuthStore } from '@/modules/authentication';
import { useSaveJob } from '@/modules/job/application';

import { useToast } from '@packages/web-design-systems';

export const useSaveJobHandler = () => {
	const saveJob = useSaveJob();
	const { isAuthenticated } = useAuthStore();
	const router = useRouter();
	const { showError, showSuccess, showWarning } = useToast();

	const execute = async (jobId: string) => {
		const result = await saveJob.submit(jobId);

		if (!isAuthenticated) {
			showWarning({ title: 'Please login to save jobs' });
			router.push(AppRoutes.auth.login);

			return;
		}

		if (result.isFailure) {
			showError({ title: 'Unable to save job' });

			return;
		}

		showSuccess({ title: 'Job Saved' });
	};

	return { execute };
};
